import { defineComponent as _defineComponent } from 'vue'
import { computed, Ref } from 'vue';
import { ServiceResult, UnitConverters } from '@/data.types';
import { formatDataPoints } from '@/data.functions';

interface Props {
  data: ServiceResult
  unitConverters: UnitConverters
}

export default /*#__PURE__*/_defineComponent({
  __name: 'movement-display',
  props: {
    data: null,
    unitConverters: null
  },
  setup(__props: any) {

const props = __props as {
  data: ServiceResult
  unitConverters: UnitConverters
};



const orion = computed(() => formatDataPoints([
  ["UNCNF_VEL", "velocity"],
  ["UNCNF_DIST_EARTH", "distance_earth"],
  ["UNCNF_DIST_MOON", "distance_moon"],
  ["CITP_VelRelEarth_Mag", "velocity"],
  ["CITP_DistEarth_Mag", "distance_earth"],
  ["CITP_DistMoon_Mag", "distance_moon"]
], props.data, props.unitConverters))

return { __sfc: true,props, orion }
}

})